import { get as _get, set as _set } from 'lodash';
/**
 * 全局配置项
 */

var GLOBAL_CONFIG = {
  api: {
    /**
     * API的根路径
     */
    root: '',

    /**
     * 加密的token
     */
    token: '',

    /**
     * 加密的key
     */
    key: ''
  },

  /**
   * 组件定义
   */
  components: {},

  /**
   * 时间格式
   */
  format: {
    date: 'YYYY-MM-DD',
    month: 'YYYY-MM',
    time: 'HH:mm:ss',
    timeRange: 'HH:mm',
    dateTime: 'YYYY-MM-DD HH:mm:ss'
  },
  features: {
    /**
     * 多语言
     */
    i18n: false,

    /**
     * 请求是不是需要生成签名
     */
    requestSign: false,

    /**
     * 请求是不是需要携带cookie
     *
     * http://visionmedia.github.io/superagent/#cors
     */
    withCredentials: false
  },

  /**
   * 国际化语言配置
   */
  language: {}
};
export var globalConfig = {
  /**
   * 根据路径获取配置值
   * @param path 属性路径
   */
  get: function get(path) {
    return _get(GLOBAL_CONFIG, path);
  },

  /**
   * 根据路径设置配置值
   * @param path 属性路径
   * @param value 配置值
   */
  set: function set(path, value) {
    _set(GLOBAL_CONFIG, path, value);
  }
};